import { NgModule } from '@angular/core';
import { JwtModule } from '@auth0/angular-jwt';

// import { AdalService } from './services/adal.service';

export function authHttpServiceFactory() {
  return localStorage.getItem('token');
}

@NgModule({
  imports: [
	JwtModule.forRoot({
		config: {
		tokenGetter: authHttpServiceFactory
		}
	})
  ]
})
export class AuthModule {}
